import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Loader from 'halogen/PulseLoader';
import { injectIntl, intlShape } from 'react-intl';
import { Download, Plus } from '../../helpers/icon-dictionary';
import messages from './messages';
import '../../styles/core.scss';
import css from './index.scss';
import Button from '../button/index';
import { DARK } from '../button/variants';

const TeacherHeader = ({ filteredTeachersCount = 0, isTeacherDataLoaded = false, isTeacherRollDownloaded = true,
    handleOnDownloadTeacherRoll, handleQuickUpload, handleAddTeacher, intl }) => {
    const teacherCount = isTeacherDataLoaded
        ? <span>{filteredTeachersCount}</span>
        : <Loader color="#000" margin="2px" size="6px" />;
    return (
        <div className={css.teacherHeaderComponent}>
            <div className={css.teachersCountContainer}>
                <span className={css.teachersTitle}>{intl.formatMessage(messages.teachers)}
                    <span className={css.teachersCount}>
                        ( {teacherCount} )
                    </span>
                </span>
            </div>
            <div className={css.buttonContainer}>
                <Button
                    containerClassName={css.downloadTeacherRoll}
                    disabled={filteredTeachersCount === 0}
                    handleOnClick={handleOnDownloadTeacherRoll}
                    icon={Download}
                    iconClassName={css.svgIconContainer}
                    label={intl.formatMessage(messages.downloadTeacherRoll)}
                    loading={!isTeacherRollDownloaded}
                    loadingLabel={intl.formatMessage(messages.downloading)}
                    variant={DARK}
                    visible />
                <Button
                    containerClassName={css.bulkUpload}
                    disabled={false}
                    handleOnClick={handleQuickUpload}
                    icon={Plus}
                    iconClassName={css.svgIconContainer}
                    label={intl.formatMessage(messages.quickUpload)}
                    variant={DARK}
                    visible />
                <Button
                    containerClassName={css.inviteTeacher}
                    disabled={!isTeacherDataLoaded}
                    handleOnClick={handleAddTeacher}
                    icon={Plus}
                    iconClassName={css.svgIconContainer}
                    label={intl.formatMessage(messages.inviteTeacher)}
                    variant={DARK}
                    visible />
            </div>
        </div>
    );
};

TeacherHeader.propTypes = {
    isTeacherDataLoaded: PropTypes.bool,
    isTeacherRollDownloaded: PropTypes.bool,
    filteredTeachersCount: PropTypes.number,
    handleOnDownloadTeacherRoll: PropTypes.func,
    handleQuickUpload: PropTypes.func,
    handleAddTeacher: PropTypes.func,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(TeacherHeader));



// WEBPACK FOOTER //
// ./app/components/teacher-header/index.js